import { useState, useEffect } from 'react';
import { EditorPane, Header } from '../../markdown-editor';
import { INITIAL_MARKDOWN } from '../../markdown-editor/constants/initialContent';
import { useWordExport } from '../../markdown-editor/hooks';
import './Canvas.scss';
import { useChatState } from '../state/chatState';
import { useChatApi } from 'api/useChat';
import { marked } from 'marked';
import { Mode } from '../state/chatState';

const Canvas: React.FC<{ mode: Mode }> = ({ mode }) => {
  const {
    state: { aiReport, isLoading, currentSessionId, promptMode, messages },
    updateReport
  } = useChatState();
  const { saveReport } = useChatApi();
  const [editable, setEditable] = useState(true);
  const { convertMarkdownToWord } = useWordExport();

  const handleExport = () => {
    const content = aiReport.content || '';
    // Check if content is already HTML (contains HTML tags)
    const isHtml = /<[a-z][\s\S]*>/i.test(content);
    // If it's not HTML, convert markdown to HTML, otherwise use as-is
    const htmlContent = isHtml ? content : (marked.parse(content) as string);
    console.log('Exporting content:', htmlContent);
    convertMarkdownToWord(htmlContent).catch((error) => {
      console.error('Failed to export Word document:', error);
    });
  };

  const handleMarkdownChange = async (markdown: string) => {
    // INSERT_YOUR_CODE

    if (isLoading.isStreaming || isLoading.isReportLoading) return;
    else {
      // INSERT_YOUR_CODE
      if ((window as any).__markdownDebounceTimer) {
        clearTimeout((window as any).__markdownDebounceTimer);
      }
      (window as any).__markdownDebounceTimer = setTimeout(async () => {
        if (promptMode === 'Research' || promptMode === 'Quick Check') {
          const res: any = await saveReport(currentSessionId?.id || '', promptMode || 'Research', markdown);
          if (res) {
            updateReport(promptMode || 'Research', markdown);
          }
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (isLoading.isStreaming) {
      setEditable(false);
      setEditable(true);
    }
  }, [isLoading.isStreaming]);
  return (
    <div>
      <div className={`canvas-container ${mode === 'horizontal' ? 'embedded' : ''}`}>
        <Header
          onExport={handleExport}
          editable={editable}
          onEditableChange={setEditable}
          isEditableVisible={false}
          isDisabled={isLoading.isStreaming}
        />

        <div className="canvas-content">
          <EditorPane markdown={aiReport.content} onMarkdownChange={handleMarkdownChange} editable={editable} />
        </div>
      </div>
    </div>
  );
};

export default Canvas;
